import React from "react";
import {
    Table,
    TableBody,
    TablePagination,
    TableContainer,
} from "@mui/material";

import { handleChangePage, handleChangeRowsPerPage } from "../../../../SharedComponents/utils/helpers/tableHelpers";
import RequestTableHeadHomePage from "../TableHeads/RequestTableHeadHomePage";
import RequestTableRowHomePage from "../TableRows/RequestTableRowHomePage";

const RequestTableHomePage = ({
    count,
    fetchedActiveCarRequests,
    rowsPerPage,
    setRowsPerPage,
    page,
    setPage,
    onRowSelect,
}) => {
    return (

        <div style={styles.tablePaddingDiv}>
            <div style={styles.tableBorderDiv}>
                <TableContainer>
                    <Table>
                        <RequestTableHeadHomePage />
                        <TableBody>
                            {fetchedActiveCarRequests.map((request) => (
                                <RequestTableRowHomePage
                                    key={request.part_request_id}
                                    carRequest={request}
                                    onSelect={() => onRowSelect(request.part_request_id)}
                                />
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 25, 50]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(event, newPage) => {
                        handleChangePage(event, newPage, setPage);
                    }}
                    onRowsPerPageChange={(event) => {
                        handleChangeRowsPerPage(event, setRowsPerPage, setPage);
                    }}
                />
            </div>
        </div>
    );
};

export default RequestTableHomePage;

const styles = {
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
};
